import React, { createContext, useContext, useState, useCallback } from 'react';

// 1. Create the context
const NotificationContext = createContext();

// 2. Create a "provider" component that will wrap your whole app
export const NotificationProvider = ({ children }) => {
  const [message, setMessage] = useState(null);
  const [type, setType] = useState('success'); // 'success' or 'error'

  // This is the function we'll call from other components
  const showNotification = useCallback((msg, msgType = 'success') => {
    setMessage(msg);
    setType(msgType);

    // Set a timer to automatically hide it after 3 seconds
    setTimeout(() => {
      setMessage(null);
    }, 4000);
  }, []);

  // Pass the message and the function to all children
  const value = { message, notificationType: type, showNotification };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

// 3. Create a simple hook to use this context
export const useNotification = () => useContext(NotificationContext);
